// Custom event names for the application
// These are defined in a separate file to avoid circular import issues

export const UPDATE_AVAILABLE_EVENT = 'sw-update-available';
